export default __webpack_public_path__ + "static/media/auth-verify-success-3.682d730b.png";